var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vs-sidebar--item ",class:[
    { 'vs-sidebar-item-active': _vm.activeLink },
    { 'disabled-item pointer-events-none': _vm.isDisabled }
  ]},[(_vm.to)?_c('router-link',{staticClass:"text-white",class:[
      { 'router-link-active': _vm.activeLink },
      { 'font-semibold': _vm.activeLink }
    ],attrs:{"tabindex":"-1","exact":"","to":_vm.to,"target":_vm.target}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }